export class Check {
  id: number;
  entry_group_id: number;
  bank_account_id: number;
  weekly_rate_id: number;
  allocation_type_id: number;
  bill_type_id: number;
  matter_id: number;
  check_number: number;
  amount: number;
  status: string = 'O';
  description: string;
  is_printed: boolean;
  type: string;
  created_at: any;
  updated_at: any;
  chart_of_account_id: number;
  contact_id: number;
  address_id: number;
  category: string;
  paid_bill_id: number;
  deposit_id: number;
  for_entry_id: number;
  invoice_id: number;
  reverse_entry_id: number;
  rate_type_id: number;
  deduction_id: number;
  document_id: number;
  position: number;
  entriescol: string;
  payment_method_id: number;
  surcharge_amount: number;
  billing_id: number;
  bill_type_name: string;
  vendor_id: any;

  valid(): boolean {
    if (this.address_id && this.contact_id && this.amount) return true;
    else return false;
  }
}
